export const DOWNLOAD_TYPE = {
  REPORT: 'REPORT',
  SUPPORTING_DOCUMENTS: 'SUPPORTING_DOCUMENTS',
  ALL: 'ALL',
};
